/**
 * Synchronizes desktop heights for two-column hero blocks.
 */
function updateHeroBlockHeights() {
  if (window.innerWidth > 1024) {
    const heroBlocks = document.querySelectorAll('.hero-block.hero-columns.two-blocks');
    heroBlocks.forEach(function(block) {
      const textWrapper = block.querySelector('.hero-text-block');
      const imageBlock  = block.querySelector('.hero-image-block img');
      if (textWrapper && imageBlock) {
        imageBlock.style.height = textWrapper.offsetHeight + 'px';
      }
    });
  } else {
    // Reset on smaller viewports
    const imageBlocks = document.querySelectorAll('.hero-block.hero-columns.two-blocks .hero-image-block');
    imageBlocks.forEach(function(imageBlock) {
      imageBlock.style.height = '';
    });
  }
}

// Use the load event to ensure fonts, images, and other assets are loaded
window.addEventListener('load', updateHeroBlockHeights);

// Also update on resize for dynamic changes
window.addEventListener('resize', updateHeroBlockHeights);